var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 40,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 40,
  fill: "#A8A8A8",
  rx: 6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M32.5 0v40M17.5 0v40M50 21H32.5m-15 0H0"
})));
export default SvgCreditCard;